// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { AuthConsumer } from '../auth/AuthContext';
import { PREVIOUSLY_IN_INK } from '../../utils/auth-jwt';
import { INK_TOOLING_MEDIA_URL } from './utils/constants';

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightGray};
`;

const LogoSection = styled.div`
  display: flex;
  align-items: center;
  
  img {
    margin-right: 8px;
  }
  
  .logo-text {
    font-size: 16px;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.textPrimary};
  }
  
  .logo-line {
    width: 1px;
    height: 24px;
    background-color: ${({ theme }) => theme.colors.borderLight};
    margin: 0 16px;
  }
`;

const HeaderNav = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const HeaderLink = styled(Link)`
  color: ${({ theme }) => theme.colors.textPrimary};
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;

  &:hover {
    color: ${({ theme }) => theme.colors.deepIndigo};
    text-decoration: none;
    font-weight: 700;
  }
`;

const AdminDevToolsLink = styled(Link)`
  display: flex;
  height: 32px;
  padding: 0 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.neutralBlack};
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.textPrimary};
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;

  &:hover {
    color: ${({ theme }) => theme.colors.deepIndigo};
    text-decoration: none;
    font-weight: 700;
  }
`;

const SignOutButton = styled.button`
  border: none;
  background: ${({ theme }) => theme.colors.grayNeutralLight};
  color: ${({ theme }) => theme.colors.white};
  font-size: 14px;
  font-weight: 500;
  padding: 6px 16px;
  border-radius: 4px;
  cursor: pointer;
`;

const SQUID_URL = `https://${ process.env.REACT_APP_PROJECT_ENV !== "prod" ? "stage.fusion." : ""}inquirer.com/squid`;
const COMPOSER_URL = `https://${ process.env.REACT_APP_PROJECT_ENV !== "prod" ? "sandbox." : "" }pmn.arcpublishing.com/composer`;

const HomePageHeader: React.FC = () => {
  return (
    <HeaderContainer>
      <HeaderLink to="/home">
        <LogoSection>
          <img width="48px" height="43px" src={`${INK_TOOLING_MEDIA_URL}/ink-logo.svg`} alt="Ink. logo" />
        </LogoSection>
      </HeaderLink>
      <HeaderNav>
        <HeaderLink target="_blank" to={SQUID_URL}>
        <img width="16px" src={`${INK_TOOLING_MEDIA_URL}/squid-logo.webp`} alt="Squid" />
        <span>Squid</span></HeaderLink>
        <HeaderLink target="_blank" to={COMPOSER_URL}>
          <img width="16px" src={`${INK_TOOLING_MEDIA_URL}/arc-logo.webp`} alt="Arc Composer" />
          <span>Composer</span>
        </HeaderLink>
        <AdminDevToolsLink to="/admin">
          <img width="16px" src={`${INK_TOOLING_MEDIA_URL}/settings-5-fill-3.svg`} alt="Admin & Dev Tools" />
          Admin & Dev Tools
        </AdminDevToolsLink>
        <AuthConsumer>
          {({ logout }) => (
            <SignOutButton
              onClick={() => {
                localStorage.removeItem(PREVIOUSLY_IN_INK);
                logout();
              }}
            >
              Sign Out
            </SignOutButton>
          )}
        </AuthConsumer>
      </HeaderNav>
    </HeaderContainer>
  );
};

export default React.memo(HomePageHeader);
